module.exports = __webpack_public_path__ + "img/icon_goumaili_qiandai.6855aa40.png";